import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { getRequest } from '../../../../../api/ApiService';
import { fetchTeamMetrics } from '../../../../../api/MetricsService';
import { fetchFinancialStatements } from '../../../../../api/FinancialStatementsService';
import Teams from '../../../../../api/Teams';
import Auth from '../../../../../routes/Auth';
import { Loader } from 'react-loaders';
import AbbreviatedMillionNumberFormat from "../../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class EpsStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      netIncome: 0,
      shares: 0,
      earningsPerShare: 0,
      earningsPerShareTarget: 0
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    const gameId = Number(Auth.getGameId());
    const team = Teams.currentTeam();
    const teamId = Number(team.id);

    Promise.all([
      fetchTeamMetrics(teamId, roundId),
      fetchFinancialStatements({ roundNumber: activeRound }),
      getRequest(`${process.env.REACT_APP_API_URL}v2/games/targets/?course=${Auth.getCourseId()}`),
    ])
      .then(([metricsResults, financialData, targetsRes]) => {
        const currentRoundMetrics = metricsResults.find(i => (
          Number(i.game) === gameId && Number(i.round) === roundId
        ));
        const earningsPerShare = currentRoundMetrics ? Number(currentRoundMetrics.earnings_per_share || 0) : 0;
        const shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;

        const incomeStatement = financialData.incomeStatement;
        const currentRoundIncomeStatement = incomeStatement.find(i => i.Round === activeRound);
        const netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;

        const targets = targetsRes.body;
        const currentRoundTargets = targets.find(i => i.round_number === activeRound);
        const earningsPerShareTarget = currentRoundTargets.earnings_per_share;

        this.setState({
          loaded: true,
          netIncome: netIncome,
          shares,
          earningsPerShare,
          earningsPerShareTarget
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      netIncome,
      earningsPerShare,
      earningsPerShareTarget,
      shares,
    } = this.state;
    const { previousShownErrors } = this.props;

    const negativeEarningsPerShare = earningsPerShare < 0 ? "-" : "";
    const negativeEarningsPerShareTarget = earningsPerShareTarget < 0 ? "-" : "";

    const earningsPerShareFormatted = `${negativeEarningsPerShare}$${Number(Math.abs(earningsPerShare)).toFixed(2)}`;
    const earningsPerShareWithColor = negativeEarningsPerShare
      ? <b>{earningsPerShareFormatted}</b>
      : earningsPerShareFormatted;

    const earningsPerShareTargetFormatted = `${negativeEarningsPerShareTarget}$${Number(Math.abs(earningsPerShareTarget)).toFixed(2)}`;
    const earningsPerShareTargetWithColor = negativeEarningsPerShareTarget
      ? <b>{earningsPerShareTargetFormatted}</b>
      : earningsPerShareTargetFormatted;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="EPS"
        previousShownErrors={previousShownErrors}
        alertText="Your net profit was not enough."
        paragraph2={(
          <Fragment>
            The net profits of {Number((netIncome / 1000000).toFixed(2))}, which resulted in an EPS of {earningsPerShareWithColor} was not enough to hit your EPS target of {earningsPerShareTargetWithColor}
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#2da548">
              Earnings Per Share<br />
              (EPS)
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Net Profits
              <span className='divider' />
              Average Total Shares
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={netIncome}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={shares}
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: 'rgba(45, 165, 72, 0.12)',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default EpsStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/eps/step2.js